import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider, App as AntApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import App from './App';
import './recovered-business-20260918.css';
import './styles.css';
import './crm-internal-sync.css';
import './crm-business-overlays.css';
import './category-equipment-centered.css';
import './list-layout.css';

dayjs.locale('zh-cn');
const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 20_000 } } });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN} theme={{
      token: { colorPrimary: '#527D69', colorInfo: '#527D69', colorSuccess: '#1E8E68', colorWarning: '#D48A00', borderRadius: 4, fontFamily: '"PingFang SC", "Microsoft YaHei", Arial, sans-serif', controlHeight: 34, fontSize: 14 },
      components: { Button: { controlHeight: 34 }, Table: { headerBg: '#F5F7F8', headerColor: '#263238', rowHoverBg: '#F3FAF7', cellPaddingBlock: 12 }, Menu: { darkItemBg: '#0B211B', darkSubMenuItemBg: '#0B211B', darkItemSelectedBg: '#163E33', darkItemSelectedColor: '#FFFFFF', darkItemColor: '#B6C6C0' } },
    }}>
      <AntApp>
        <QueryClientProvider client={queryClient}><App /></QueryClientProvider>
      </AntApp>
    </ConfigProvider>
  </React.StrictMode>,
);

